import axios from 'axios';
import { baseUrl } from '../config';
import history from '../history';

const postWithAuth = async (path, body) => {
    const token = localStorage.getItem('token');
    try {
        const res = await axios.post(baseUrl + path, body, {
            headers: { 'x-access-token': token },
        });
        if (res.data && res.data.success) {
            return { success: true, data: res.data.data };
        }
        return { success: false, error: (res.data && res.data.message) || 'Unknown error' };
    } catch (e) {
        if (e && e.response && e.response.status === 401) {
            localStorage.removeItem('token');
            history.push('/');
            return { success: false, error: 'Unauthorized' };
        }
        const message =
            (e && e.response && e.response.data && e.response.data.errors && e.response.data.errors.message) ||
            (e && e.message) ||
            'Network error';
        return { success: false, error: message };
    }
};

export const fetchInternationalTicketsDashboard = (body) =>
    postWithAuth('-complaint/v1/international-tickets/dashboard', body);

export const fetchInternationalTicketsList = (body) =>
    postWithAuth('-complaint/v1/international-tickets/list', body);
